import React from 'react';
import { motion } from 'framer-motion';
export function Family() {
  return <div className="pt-32 md:pt-40 pb-24" data-id="element-209" data-mp="3ku30uz15oy31">
      {/* Page Header */}
      <section className="text-center mb-16 px-4" data-id="element-210" data-mp="3kvw3m38ney5r">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-211" data-mp="3dtgh9m66dgl">
          <span className="text-amber font-medium tracking-widest uppercase text-sm mb-3 block" data-id="element-212" data-mp="cgchdo6eag07">
            The People Behind the Food
          </span>
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-charcoal mb-6" data-id="element-213" data-mp="mcpb2m1xwtuy">
            The Cheah Family
          </h1>
          <div className="w-24 h-1 bg-warm-brown mx-auto" data-id="element-214" data-mp="hdvxyuqkf4vb"></div>
          <p className="text-gray-600 text-lg mt-8 max-w-2xl mx-auto leading-relaxed" data-id="element-215" data-mp="2o30q40i8gap8">
            At Freddie Cheah, family isn't just important — it's everything. Our
            restaurant is built on the values of togetherness, tradition, and
            sharing great food with the people you love.
          </p>
        </motion.div>
      </section>

      {/* Family Photo - Full Width */}
      <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 mb-20" data-id="element-216" data-mp="29y31k5mj7bb8">
        <motion.div initial={{
        opacity: 0,
        scale: 0.98
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative group overflow-hidden shadow-2xl" data-id="element-217" data-mp="2epb72qkqqcj4">
          <div className="aspect-[4/3] md:aspect-[3/2] w-full relative" data-id="element-218" data-mp="2sqdx1eeuw6zb">
            <img src="https://cdn.magicpatterns.com/uploads/oEUTfvMyAcaLXeSrx4fhsU/Cheah-Family.jpg" alt="The Cheah Family" className="absolute inset-0 w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-[1.02]" data-id="element-219" data-mp="2xop4xjllc7ew" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent" data-id="element-220" data-mp="26ka7qhfq9kbj"></div>
          </div>
          {/* Decorative frame */}
          <div className="absolute inset-4 border border-white/15 pointer-events-none" data-id="element-221" data-mp="2flqhcmypxiep"></div>
        </motion.div>
        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.6
      }} className="text-center text-gray-500 text-sm mt-4 italic" data-id="element-222" data-mp="2amx0qlo4xbab">
          The Cheah family together
        </motion.p>
      </section>

      {/* Freddie & Jo Section */}
      <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 mb-20" data-id="element-223" data-mp="2ye2fsym93zjk">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-224" data-mp="2ub631oje6xnj">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative" data-id="element-225" data-mp="38b73j2vqw32h">
            <div className="aspect-[3/4] w-full max-w-md mx-auto lg:mx-0 relative group overflow-hidden shadow-xl" data-id="element-226" data-mp="3czq1wpc0le52">
              <img src="https://cdn.magicpatterns.com/uploads/uQXuf7bqSSM2hVa4ivmM7K/Freddie_and_Jo.jpg" alt="Freddie and Jo Cheah" className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105" data-id="element-227" data-mp="3hwq8d1cs0iwp" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent" data-id="element-228" data-mp="2ua9zfwgrrbm0"></div>
            </div>
            <div className="absolute -bottom-4 -left-4 w-32 h-32 border-b-2 border-l-2 border-amber/30 -z-10 hidden lg:block" data-id="element-229" data-mp="2l7r3lwbehz99"></div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="text-center lg:text-left" data-id="element-230" data-mp="2p8ugqb22dh6s">
            <span className="text-amber font-medium tracking-widest uppercase text-sm mb-3 block" data-id="element-231" data-mp="23f6uxxepm0yw">
              Where It All Began
            </span>
            <h2 className="font-serif text-3xl md:text-4xl text-charcoal mb-6" data-id="element-232" data-mp="1ugbnyj3ucmuj">
              Freddie & Jo
            </h2>
            <div className="space-y-5 text-gray-600 leading-relaxed text-lg" data-id="element-233" data-mp="1pi0g2dx3wmey">
              <p data-id="element-234" data-mp="1kjgtcbaov6lj">
                Freddie and Jo Cheah are the heart and soul behind Paducah's
                newest dining destination. Their shared love of food, family,
                and community inspired them to create a place where everyone
                feels welcome.
              </p>
              <p data-id="element-235" data-mp="3nce08lsusjsr">
                Drawing from Freddie's deep roots in Asian culinary traditions
                and Jo's warm hospitality, they've built more than a restaurant
                — they've built a gathering place for the Paducah community.
              </p>
            </div>
            <div className="mt-8" data-id="element-236" data-mp="4zplzqa2pbyh">
              <div className="w-16 h-1 bg-warm-brown mx-auto lg:mx-0" data-id="element-237" data-mp="4yxy71mpwiir"></div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Family Values */}
      <section className="bg-charcoal relative py-20 overflow-hidden" data-id="element-238" data-mp="38h7s9ta76aws">
        <div className="absolute inset-0 brick-pattern opacity-10" data-id="element-239" data-mp="3dfj0y0orafdf"></div>
        <div className="absolute inset-0 bg-charcoal/85" data-id="element-240" data-mp="3dhc7zh3a71ly"></div>

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-241" data-mp="3if5gwhvyy9px">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-242" data-mp="snz4ojbzpjle">
            <span className="font-serif text-6xl text-amber/20 leading-none block mb-2" data-id="element-243" data-mp="33948onizc91">
              "
            </span>
            <blockquote className="font-serif text-2xl md:text-3xl text-cream leading-relaxed italic -mt-4" data-id="element-244" data-mp="czc5ztegt8vg">
              Food has always been how our family comes together. We wanted to
              share that feeling with Paducah — a place where every meal feels
              like coming home.
            </blockquote>
            <div className="mt-8 flex items-center justify-center" data-id="element-245" data-mp="3v5qtok2jcx71">
              <div className="w-12 h-px bg-amber mr-4" data-id="element-246" data-mp="3qe8sbuwloulj"></div>
              <p className="text-cream font-medium tracking-wider uppercase text-sm" data-id="element-247" data-mp="3qcnwm1yjv5m3">
                The Cheah Family
              </p>
              <div className="w-12 h-px bg-amber ml-4" data-id="element-248" data-mp="2xpjnplwc6751"></div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>;
}